<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  showTutorial: {
    type: String,
    default: null,
  },
})

const help = () => {
  if (props.showTutorial) {
    window.open(props.showTutorial, '_blank', 'noopener,noreferrer')
  }
}
</script>

<template>
  <div class="flex w-full flex-col bg-white">
    <!-- Hero Content Section -->
    <div class="border-neutral-30 flex w-full justify-center border-b-0 px-4.5 py-10 md:px-3">
      <!-- Hero Content -->
      <div class="flex w-full flex-col md:px-10">
        <!-- Slot para conteúdo customizado -->
        <slot name="content">
          <!-- Conteúdo padrão -->
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div class="flex flex-col gap-2">
                <h1 v-if="title" class="text-neutral-90 text-[32px] leading-10 font-semibold">
                  {{ title }}
                </h1>
                <p v-if="subtitle" class="text-neutral-60 max-w-[559px] text-lg">{{ subtitle }}</p>
              </div>
              <div class="hidden shrink-0 sm:flex sm:flex-col sm:gap-2">
                <slot name="actions" />
              </div>
            </div>
            <div
              v-if="showTutorial"
              class="border-info-30 bg-info-0 flex w-full cursor-pointer flex-row items-center justify-between rounded-lg border px-4 py-2 sm:max-w-[374px]"
              @click="help"
            >
              <div>
                <p class="text-primary-90 text-xs font-semibold">
                  Está com dúvida de como usar a funcionalidade?
                </p>
                <p class="text-primary-70 text-xs font-normal">Assista o tutorial que preparamos</p>
              </div>
              <ImoIcon name="arrow-right-01" class="text-info-70" />
            </div>
            <div class="flex w-full flex-col gap-2 sm:hidden">
              <slot name="actions" />
            </div>
          </div>
        </slot>
      </div>
    </div>

    <!-- Tabs Section - Slot para tabs na borda inferior -->
    <div class="border-neutral-30 flex w-full justify-start border-b px-4 md:px-12">
      <div class="mb-[-1px] flex w-full min-w-0 flex-col">
        <slot name="tabs">
          <!-- Aqui ficará o ImoTabs quando necessário -->
        </slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
@reference "@/assets/style/main.css";

.hero-actions {
  @apply flex flex-wrap gap-4;
}
</style>
